import React from "react";
import { DefaultToolbar } from "colbi_web_ui/lib/components";
import { SovosToolbarActions, SovosToolbarGroup } from "mosaic-react";
import { DataGridTabs } from "colbi_web_ui/lib/components";
import styles from "./AuditToolbar.module.sass";

const AuditToolbar = ({ toolbarProps, defaultToolbarProps }) => {
    const { tabsProps } = toolbarProps;

    return (
        <SovosToolbarGroup sx={{ width: "100%" }}>
            <SovosToolbarGroup className={styles["toolbar-group"]}>
                <DataGridTabs {...tabsProps} />
            </SovosToolbarGroup>
            <SovosToolbarGroup>
                <SovosToolbarActions>
                    <DefaultToolbar {...defaultToolbarProps} />
                </SovosToolbarActions>
            </SovosToolbarGroup>
        </SovosToolbarGroup>
    );
};

export default AuditToolbar;
